interface OutlineButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
  className?: string;
}

export const OutlineButton: React.FC<OutlineButtonProps> = ({ 
  children, 
  onClick, 
  disabled = false,
  active = false,
  className = '' 
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-6 py-3 rounded-xl transition-all duration-300 
        ${active 
          ? 'bg-white/80 text-gray-800 border-2 border-orange-500' 
          : 'bg-white/80 text-gray-800 border-2 border-gray-200 hover:border-orange-300'
        } ${className}`}
    >
      {children}
    </button>
  );
}; 